import { IconName } from '@bytel/trilogy-assets/lib/iconNameEnum';

import { paths } from '@helpers/path';

import { PlanTypeId } from '@constants/plan';
import { BUTTON_STYLE, ELIGIBILITY_JOURNEY, TECHNOLOGY } from '@constants/provider';

import { EligibilityJourneyConfig } from './eligibility-config';

export class YoungJourneyConfig extends EligibilityJourneyConfig {
    protected readonly name = ELIGIBILITY_JOURNEY.MOINS_26_ANS;
    protected readonly showComparatorSelection = false;
    protected readonly offerCategoryCodeToShow: PlanTypeId = PlanTypeId.FAI_26;
    protected readonly wordings = {
        mainTitle: "Vous avez choisi l'offre -26\u00A0ans\u00A0!",
        subTitle: 'On regarde ensemble si cette offre est bien disponible chez vous\u00A0?',
        noFiber: "En attendant l'arrivée de la fibre...",
        results: {
            [TECHNOLOGY.FTTH]: "Bonne nouvelle\u00A0! Vous pouvez profiter de l'offre -26\u00A0ans\u00A0!",
            [TECHNOLOGY.BOX_5G]: "Bonne nouvelle\u00A0! Vous pouvez profiter de l'offre -26\u00A0ans\u00A0!",
            [TECHNOLOGY.BOX_4G]: "Bonne nouvelle\u00A0! Vous pouvez profiter de l'offre -26\u00A0ans\u00A0!",
        },
    };
    protected readonly tracking = {
        page: 'Eligibilite_accueil_xg_box_offre_26_ans',
        pageCategory: 'Eligibilite',
        eCommerceStep: '',
        universe: 'Boutique_Fai',
        marketLine: 'Fai',
        variant: {
            type_offres: 'Offres_xg_box_26_ans',
        },
    };
    protected readonly mismatch = {
        icon: IconName.EXCLAMATION_CIRCLE,
        // title: "Aie\u00A0! Votre logement ne nous permet pas de vous proposer l'offre -26\u00A0ans.",
        alertTitle: "La fibre ou la 4G/5G sont nécessaires pour profiter de l'offre -26\u00A0ans.",
        alertDescription: "En attendant d'être éligible, vous pouvez voir les offres disponibles chez vous.",
        showAddress: true,
        showDivider: false,
        trackingClic: {
            event: 'clic',
            actionClic: 'Clic_redirection',
            categorieClic: 'Non_eligible_moins_26_ans',
            nomClic: 'Voir_les_offres',
        },
        trackingImpression: {
            categorieClic: 'Poppin_eligibilite_ko_moins_26_ans',
            nomClic: 'Eligibilite_ko_moins_26_ans',
        },
        buttonLabel: 'Voir les offres disponibles',
        buttonStyle: BUTTON_STYLE.PRIMARY,
        ctaRedirectUrl: paths.eligibilityTest,
    };
    protected readonly technologies = [TECHNOLOGY.FTTH, TECHNOLOGY.BOX_5G, TECHNOLOGY.BOX_4G];
    protected readonly extraCmsBlockByTab = {};
}
